// A modified version of IconSquareChecklistBell where the bell is replaced with a star
export const IconWorkflows = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.02832 5.99854L5.77832 6.49854L7.02608 4.83487M9.03831 5.66671H11.0383M5.02832 10.4993L5.77832 10.9993L7.02608 9.33562M13.6663 7.33337V2.33337H2.33301V13.6667H8.1649"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.333 7.81653L10.333 9.81653L8.33301 10.8165L10.333 11.8165L11.333 13.8165L12.333 11.8165L14.333 10.8165L12.333 9.81653L11.333 7.81653Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
